/** 404 page copy in Arabic. Mirrors `../en/notFound.js` key for key. */

export const NOT_FOUND = {
  eyebrow: '404',
  title: 'الصفحة غير موجودة',
  text: 'الصفحة التي تبحث عنها غير موجودة أو تم نقلها.',
  cta: { label: 'العودة إلى الرئيسية', href: '/' },
}
